"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidationAlias = void 0;
var getValidationAlias = function (globals) {
    return {
        fontFamily: globals.fonts.secondary.regular,
    };
};
exports.getValidationAlias = getValidationAlias;
